/**
 * Main styling file for the Project Card Component
 *
 * @author Creator-Solutions -> Owen Burns
 */

import styled from "styled-components";

const ProjectCardContainer = styled.div`
  width: 38vw;
  height: 75vh;
  display: flex;
  flex-direction: column;
  border: 1px solid #4169e1;
`;

const ProjectIconContainer = styled.div`
  width: 38vw;
  height: 25vh;
  justify-content: center;
  display: flex;
  border: 1px solid #fff;
`;

const ProjectTitleContainer = styled.div`
  width: 38vw;
  height: 8vh;
  display: flex;
  border: 1px solid #fff;
`;

const ProjectIcon = styled.img`
  width: 50px;
  height: 50px;
  align-self: center;
`;

const ProjectTitle = styled.a`
  color: #fff;
  font-size: 22px;
  text-decoration: none;
  align-self: center;
  margin-left: 25px;
`;

export {
  ProjectIcon,
  ProjectTitle,
  ProjectIconContainer,
  ProjectCardContainer,
  ProjectTitleContainer,
};
